import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    //ALLOCATION PAGE VALUES
    selected: [],
    allocations: [],
    loading: false,
    dates: [],
    filterBy: '',
    filterCol: '',
    filterDate: '',
    fetchAllocations: false,
    showVoid: false
    // defaultHeaders: [
    //     'date',
    //     // 'details',
    //     'site.project.name',
    //     'site.name',
    //     'tip.name',
    //     'spoil.name',
    //     'vehicleType.name',
    //     'vehicle.name',
    // ],
  },
  mutations: Mutations,
  actions: {},
  getters: {}
}
